var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-dropzone',{ref:"mediaDropzone",attrs:{"id":"media-uploader-dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.onSuccess,"vdropzone-error":_vm.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }